import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import styled from 'styled-components';
import humanparser from 'humanparser';

import Sidebar from '../../components/Donation/Sidebar';
import DetailsForm from '../../components/Donation/DetailsForm';
import DetailsFormMobile from '../../components/Donation/DetailsFormMobile';
import DetailsFormPandaPay from '../../components/Donation/DetailsFormPandaPay';
import DonationSubmitting from '../../components/Donation/DonationSubmitting';
import ToasterAlert from '../../components/Donation/ToasterAlert';
import accounting from 'accounting';
import CssTransition from '../../components/Transition/CssTransition';
import { TransitionGroup } from 'react-transition-group';

import OverlayPartner from '../Widget/OverlayPartner';
import { setOverlayPartnerVisible, onGoToNextCard } from '../Widget/actions.js';

import TransitionContainer from '../../components/Transition/TranstionContainer';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

import { CardTypes } from '../../utils/enums';
import {
    getNextAction,
    buildConditionalActionsAnswerHistory
} from '../../utils/nextActionUtil';
import { handleSkippingEndCard } from '../../utils/handleSkippingEndCard';
import { cacheFormData } from '../../utils/formCaching/actions';

import { onBackToAmount, submitDonation, mobileGoWizardStep } from './actions.js';

const DonationDetailsContainer = styled.div`
    display: ${props => (props.isVisible ? 'flex' : 'none')};
    flex-direction: row;
    flex: 1;
`;

const Container = styled.div`
    display: flex;
    flex-direction: row;
    flex: 1;
    background-color: white;
`;

const DonationDetails = props => (
    <TransitionContainer zIndex={12} isSubmitting={props.isSubmitting}>
        <Container>
            <TransitionGroup>
                {props.donationSubmitError && (
                    <CssTransition key="alert" in={props.donationSubmitError}>
                        <ToasterAlert content={props.donationSubmitError} />
                    </CssTransition>
                )}
            </TransitionGroup>
            <TransitionGroup>
                {props.isSubmitting && (
                    <CssTransition
                        key="loading"
                        in={props.isSubmitting}
                        timeoutInMs={650}
                    >
                        <TransitionContainerNoExit noAnimation={true}>
                            <DonationSubmitting
                                isMobileResolution={props.isMobileResolution}
                            />
                        </TransitionContainerNoExit>
                    </CssTransition>
                )}
            </TransitionGroup>
            <OverlayPartner transitionType="left-to-right" />
            <DonationDetailsContainer isVisible={!props.isSubmitting}>
                {!props.isMobileResolution && (
                    <Sidebar
                        amount={props.amountFormated}
                        partnerLogo={props.partnerLogo}
                        paymentMethod={props.paymentMethod}
                        onPartnerClick={() => props.setOverlayPartnerVisible(true)}
                    />
                )}
                {props.isMobileResolution ? (
                    <DetailsFormMobile
                        onBackToAmount={props.onBackToAmount}
                        amountFormated={props.amountFormated}
                        mobileWizardStep={props.mobileWizardStep}
                        mobileGoWizardStep={props.mobileGoWizardStep}
                        progressPercentage={props.mobileProgressPercentage}
                        partnerLogo={props.partnerLogo}
                        partnerName={props.partnerName}
                        paymentMethod={props.paymentMethod}
                        onPartnerClick={() => props.setOverlayPartnerVisible(true)}
                        onSubmit={() =>
                            props.submitDonation(
                                props.apiRequestData,
                                props.mobileFormValues,
                                props.amount,
                                props.paymentMethod,
                                props.selectedAmountTime,
                                props.isMultiActionsCard,
                                props.actionIdentifier,
                                props.feedbackText,
                                props.partnerName
                            )
                        }
                    />
                ) : (
                    <DetailsForm
                        onSubmit={values => {
                            props.cacheFormData(values);
                            props.submitDonation(
                                props.apiRequestData,
                                values,
                                props.amount,
                                props.paymentMethod,
                                props.selectedAmountTime,
                                props.isMultiActionsCard,
                                props.actionIdentifier,
                                props.feedbackText,
                                props.partnerName
                            );
                        }}
                        onBackToAmount={props.onBackToAmount}
                        amountFormated={props.amountFormated}
                        partnerName={props.partnerName}
                    />
                )}
                {props.paymentMethod === 'PandaPay' ? (
                    <DetailsFormPandaPay formValues={props.mergedFormValues} />
                ) : null}
            </DonationDetailsContainer>
        </Container>
    </TransitionContainer>
);

DonationDetails.propTypes = {
    nextAction: PropTypes.object,
    onBackToAmount: PropTypes.func.isRequired,
    submitDonation: PropTypes.func.isRequired,
    mobileGoWizardStep: PropTypes.func.isRequired,
    amount: PropTypes.number.isRequired,
    amountFormated: PropTypes.string.isRequired,
    partnerLogo: PropTypes.string,
    partnerName: PropTypes.string.isRequired,
    paymentMethod: PropTypes.string.isRequired,
    apiRequestData: PropTypes.object.isRequired,
    isSubmitting: PropTypes.bool.isRequired,
    isMobileResolution: PropTypes.bool.isRequired,
    mobileWizardStep: PropTypes.number,
    mergedFormValues: PropTypes.object,
    mobileFormValues: PropTypes.object,
    mobileProgressPercentage: PropTypes.number,
    donationSubmitError: PropTypes.string,
    selectedAmountTime: PropTypes.instanceOf(Date),
    setOverlayPartnerVisible: PropTypes.func.isRequired,
    isMultiActionsCard: PropTypes.bool.isRequired,
    actionIdentifier: PropTypes.string.isRequired,
    feedbackText: PropTypes.string.isRequired,
    cards: PropTypes.array.isRequired,
    skipEndCard: PropTypes.bool,
    onGoToNextCard: PropTypes.func.isRequired,
    handleSkippingEndCard: PropTypes.func.isRequired,
    cacheFormData: PropTypes.func.isRequired
};

const getMobileFormValues = formState => {
    const step1Values =
        formState.donationDetailsFormStep1 != null
            ? formState.donationDetailsFormStep1.values
            : {};
    const step2Values =
        formState.donationDetailsFormStep2 != null
            ? formState.donationDetailsFormStep2.values
            : {};

    return { ...step1Values, ...step2Values };
};

const getMergedFormValues = formState => {
    let mergedFormValues = formState.donationDetailsForm
        ? formState.donationDetailsForm.values
        : getMobileFormValues(formState);

    const name = humanparser.parseName(mergedFormValues.fullName || '');
    mergedFormValues.firstName = name.middleName
        ? name.firstName + ' ' + name.middleName
        : name.firstName;
    mergedFormValues.lastName = name.lastName;

    return mergedFormValues;
};

const getMobileProgressPercentage = formState => {
    let completePercentage = 10;

    if (!isFieldNotValid(formState.donationDetailsFormStep1, 'fullName')) {
        completePercentage += 16;
    }
    if (!isFieldNotValid(formState.donationDetailsFormStep1, 'email')) {
        completePercentage += 16;
    }
    if (!isFieldNotValid(formState.donationDetailsFormStep2, 'cardNumber')) {
        completePercentage += 16;
    }
    if (!isFieldNotValid(formState.donationDetailsFormStep2, 'expDate')) {
        completePercentage += 16;
    }
    if (!isFieldNotValid(formState.donationDetailsFormStep2, 'cvv')) {
        completePercentage += 16;
    }

    return completePercentage;
};

const isFieldNotValid = (mergedForm, fieldName) => {
    return (
        !mergedForm ||
        !mergedForm.values ||
        !mergedForm.values[fieldName] ||
        (mergedForm.syncErrors && mergedForm.syncErrors[fieldName])
    );
};

export default connect(
    state => {
        const nextAction = getNextAction(
            state.widget.actions,
            state.widget.activeAction.identifier,
            buildConditionalActionsAnswerHistory(state),
            state.widget.cards
        );

        return {
            nextAction,
            isSubmitting: state.donation.isSubmitting,
            mobileWizardStep: state.donation.mobileWizardStep,
            amount: state.donation.selectedAmount,
            amountFormated: accounting.formatMoney(state.donation.selectedAmount, '$', 0),
            partnerLogo: state.widget.activeAction.partner.logoUrl,
            partnerName: state.widget.activeAction.partner.name,
            paymentMethod: state.widget.activeAction.partner.paymentMethod,
            apiRequestData: state.widget.apiRequestData,
            isMobileResolution: state.widget.isMobileResolution,
            mergedFormValues: getMergedFormValues(state.form),
            mobileFormValues: getMobileFormValues(state.form),
            mobileProgressPercentage: getMobileProgressPercentage(state.form),
            donationSubmitError: state.donation.donationSubmitError,
            selectedAmountTime: state.donation.selectedAmountTime,
            isMultiActionsCard:
                state.widget.cards[state.widget.activeAction.order - 1].type ===
                CardTypes.multipleActions,
            actionIdentifier: state.widget.activeAction.identifier,
            feedbackText: state.widget.activeAction.thankYouText || '',
            skipEndCard: state.widget.activeAction.skipEndCard && !!nextAction,
            cards: state.widget.cards
        };
    },
    {
        onBackToAmount,
        submitDonation,
        mobileGoWizardStep,
        setOverlayPartnerVisible,
        onGoToNextCard,
        handleSkippingEndCard,
        cacheFormData
    }
)(DonationDetails);



// WEBPACK FOOTER //
// ./src/containers/Donation/DonationDetails.jsx